// Public types for the WebCodecs-based player + b2 SEI metadata parser.
// Layered intentionally:
//   - sample/track records describe what the box walker produces
//   - b2 SEI types describe what the SEI parser produces
//   - Playback consumes both and renders to canvas
// SEI ext_id byte values from b2.h
export const B2_EXT = {
    NONE: 0x00,
    OVERLAY: 0x01,
    DRIVE: 0x02,
    POS: 0x04,
    VMD: 0x08,
    VMD2: 0x10,
    LPR: 0x20,
    WATERMARK: 0x40,
    OD: 0x80,
};
